export const cilChevronLeft = ["24 24","<path d='M15.332 23.292l-11.222-11.222 0.528-0.533 4.008-4.008 0.003 0.003 6.684-6.684 4.543 4.543-6.679 6.679 6.679 6.679zM8.655 14.498l0.528 0.523 6.149 6.149 2.421-2.421-6.679-6.679 6.679-6.679-2.421-2.421-9.106 9.101z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-left.js
// module id = null
// module chunks = 